import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalData } from '../../Modals/ModalData';
import BootstrapTable from 'react-bootstrap-table-next';
import 'bootstrap/dist/css/bootstrap.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator';
import overlayFactory from 'react-bootstrap-table2-overlay';


function PatientsInGroup({ handleTableChange, data, query, totalSize, isLoading, allPatientsUserAssignments, deletePatientButton }) {
    const { t } = useTranslation();

    const showNumberInProtocolColumn = data.some(
        patient => patient.numberInProtocol !== null && patient.numberInProtocol !== undefined && patient.numberInProtocol !== ''
    );

    const columns = [
        { dataField: 'fullName', text: 'Nombre', sort: false },
        {
            dataField: 'usuarios',
            text: 'Usuarios',
            sort: false,
            formatter: (_, row) => {

                const patientAssignment = allPatientsUserAssignments.find(
                    (assignment) => assignment.patientId === row.medicalRecordNumber
                );

                return patientAssignment ? patientAssignment.count : 0;
            },
        },
        
    ];

    if (deletePatientButton) {
        columns.push({
            dataField: 'actions2',
            text: 'Acciones',
            formatter: (_, row) => (
                React.cloneElement(deletePatientButton, { medicalRecordNumber: row.medicalRecordNumber })
            ),
        });
    }

    if (showNumberInProtocolColumn) {
        columns.unshift(
            { dataField: 'numberInProtocol', text: 'N. Protocol', sort: false },
        );
    }

    return (
        <BootstrapTable
            classes="table-spaced table-spaced-small"
            wrapperClasses="table-responsive"
            keyField="medicalRecordNumber"
            data={data}
            columns={columns}
            bootstrap4
            bordered={false}
            hover
            striped
            loading={isLoading}
            overlay={overlayFactory({ spinner: true })}
            remote
            pagination={paginationFactory({
                page: query.pagination.page,
                sizePerPage: query.pagination.sizePerPage,
                totalSize: totalSize,
                hideSizePerPage: true,
                hidePageList: false,
            })}
            onTableChange={handleTableChange}
            noDataIndication={() => <>{t("commons.noData")}</>}
        />
    );
}

export default function GroupPatients({ props, deletePatientButton }) {
    
    const { t } = useTranslation();
    const {
        dataPatient,
        queryPatient,
        totalSizePatient,
        isPatientLoading,
        handleTableChangePatient,
        addPatients_Handler,
        handleFilterChange,
        selectedPatient,
        confirmPatient,
        allPatientsUserAssignments,
    } = props;

    return (
        <>
            <PatientsInGroup
                handleTableChange={handleTableChangePatient}
                data={dataPatient}
                query={queryPatient}
                totalSize={totalSizePatient}
                isLoading={isPatientLoading}
                allPatientsUserAssignments={allPatientsUserAssignments}
                deletePatientButton={deletePatientButton }
            />
        </>
        
    );
    
}
